import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api, setToken, formatApiError } from "./api";
import { translations } from "./i18n";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [language, setLanguage] = useState(
    () => localStorage.getItem("ct_lang") || "en"
  );

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        setLanguage(data.language || language);
      } catch {
        setUser(null);
      } finally {
        setChecking(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    setLanguage(data.user.language || "en");
    return data.user;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const loginWithGoogle = async (accessToken) => {
    // Use Google access token — backend will verify via UserInfo API
    const { data } = await api.post("/auth/google", { access_token: accessToken });
    setToken(data.token);
    setUser(data.user);
    setLanguage(data.user.language || "en");
    return data.user;
  };
  const logout = () => {
    setToken(null);
    setUser(null);
  };

  const changeLanguage = async (lang) => {
    setLanguage(lang);
    localStorage.setItem("ct_lang", lang);
    if (user) {
      try {
        const { data } = await api.patch("/auth/me", { language: lang });
        setUser(data);
      } catch (_) {}
    }
  };

  const t = useMemo(() => translations[language] || translations.en, [language]);

  const value = {
    user, setUser, checking,
    login, register, loginWithGoogle, logout,
    language, changeLanguage, t,
    formatApiError,
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
